import mitt from "mitt";

// 创建 mitt 实例
const emitter = mitt();

// 导出事件总线
export const bus = {
  // 发送事件
  emit: emitter.emit,

  // 监听事件
  on: emitter.on,

  // 移除监听
  off: emitter.off,
};

// 导出默认实例
export default bus;
